export enum AppRoutes {
  landing = 'landing',
  checkout = 'checkout',
  list = 'list',
  store = 'kvetinarstvo',
  product = 'product',
  myAccount = 'my-account',
  info = 'info',
  notFound = 'not-found',
  auth = 'auth',
  maintenance = 'maintenance',
  serviceUnavailable = 'service-unavailable',
  cooperation = 'cooperation',
  serverError = 'server-error',
}
